export default "__VITE_ASSET__f0ba2e88__"